export default __webpack_public_path__ + "static/media/distanstolkning3.3824ae99.png";